import { render, staticRenderFns } from "./Vsetting.vue?vue&type=template&id=4f050e8c"
import script from "./Vsetting.vue?vue&type=script&lang=js"
export * from "./Vsetting.vue?vue&type=script&lang=js"
import style0 from "./Vsetting.vue?vue&type=style&index=0&id=4f050e8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports